import { render, staticRenderFns } from "./PagosParciales.vue?vue&type=template&id=2b3e1e4d&scoped=true&"
import script from "./PagosParciales.vue?vue&type=script&lang=js&"
export * from "./PagosParciales.vue?vue&type=script&lang=js&"
import style0 from "./PagosParciales.vue?vue&type=style&index=0&id=2b3e1e4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3e1e4d",
  null
  
)

export default component.exports